module.exports = __webpack_public_path__ + "assets/img/login_new_01.0973824b.png";